// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
// import { getFormsDataS } from '../../../../store/company';
import CheckboxField from 'components/formFields/checkBoxField';
import { IDatosBasicos } from 'commons/interfaces';
import AutocompleteField from 'components/formFields/autocompleteField';
import DatePickerDefaultField from 'components/formFields/datePickerDefaultField';
import AutocompleteFieldCountry from 'components/formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from 'components/formFields/AutocompleteFieldDepartament';
import AutocompleteMultiple from 'components/formFields/AutocompleteMultiple';
import { getApplicationCustomerStore } from 'store/customer';


// import InputNumeric from '../formFields';

export const DatosClientes = (props:any) => {


    const dispatch = useDispatch();

    // REDUX
    const { countries_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );
    const { applicationsListSelect }:any = useSelector( (state:any) => state.customer );


    
  
    const  {  country_list_select } = useSelector( (state:any) => state.country );
    // const  {  workplace_list_select } = useSelector( (state:any) => state.workplace );
    const  {  municipaly_list_select } = useSelector( (state:any) => state.municipalies );
    const  {  departaments_list_select } = useSelector( (state:any) => state.departaments );



    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);


    const { formField: {
        // DATOS CLIENTE 
        name,
        address,
        email,
        person_in_charge,
        contact,
        second_person_in_charge,
        second_customer_contact,
        phone,
        start_date,
        status,
        country,
        departament,
        municipaly,
        applications,
        has_trial,
        trial_ends_at,
        subscription_ends_at
      }
    } = props;


    useEffect(() => {
        getDataApplicationsCustomer()
        getDataInputesForm();
     }, []);

     useEffect(() => {
       
        const data:any = [];
        for (let index = 0; index < country_list_select.length; index++) {
          
             data.push({
                 label: country_list_select[index].name,
                 value: country_list_select[index].id
             })
        }
        setCountries(data);

     }, [country_list_select]);
     
 
 
     useEffect(() => {
       setDepartaments(departaments_list_select);
     }, [departaments_list_select]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);


     const getDataApplicationsCustomer = async () => {
 
          const response = await dispatch( getApplicationCustomerStore() );
     }

     


     const getDataInputesForm = async () => {

        // const response = await dispatch( getFormsDataS() );

        
        setCountries([]);
        setDepartaments([]);
        setMunicipalies([]);
    }

    const { values, setFieldValue }: any = useFormikContext();

    useEffect(() => {
        if (values[has_trial.name] && !values[trial_ends_at.name]) {
            setFieldValue(trial_ends_at.name, moment().add(20, 'days').toDate());
        }
    }, [values[has_trial.name]]);


  return (
    <div>

        <Grid container spacing={2}>
            <Grid size={{ xs: 4 }}>
              <InputField 
                name={name.name}
                label={name.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>
            
            <Grid size={{ xs: 4 }}>
            <InputField 
                name={person_in_charge.name}
                label={person_in_charge.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            <Grid size={{ xs: 4 }}>
              <InputField 
                name={email.name}
                label={email.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            


            
            
            
        </Grid> 
        {/* END GRID  */}

        <Grid container spacing={2} style={{ marginTop: 15 }}>

            


            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldCountry
                      options={countries}
                      name={country.name}
                      label={country.label}
                      element={country.name}
                  />
            </Grid>
            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldDepartament 
                      options={departaments}
                      name={departament.name}
                      label={departament.label}
                      element={departament.name}
                  />
            </Grid>

             <Grid size={{ xs: 4 }}> 
                  <AutocompleteField 
                      options={municipaly_list_select}
                      name={municipaly.name}
                      label={municipaly.label}
                      element={municipaly.name}
                  />
            </Grid>
           
            
            
        </Grid> 
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>

             <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={contact.name}
                label={contact.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            <Grid size={{ xs: 8 }}>
              <InputField 
                name={address.name}
                label={address.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            
            
        
        </Grid> 
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid size={{ xs: 4 }}>
              <InputField 
                name={second_person_in_charge.name}
                label={second_person_in_charge.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={second_customer_contact.name}
                label={second_customer_contact.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

           <Grid size={{ xs: 4 }}>
              <InputNumeric 
                name={phone.name}
                label={phone.label}
                variant="outlined" 
                fullWidth
                autoComplete="off"
              />
            </Grid>

            


            

        </Grid>
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>
              
              <Grid size={{ xs: 4 }}>
              
                <DatePickerDefaultField label={start_date.label} 
                                name={start_date.name}/>
              </Grid> 


              <Grid size={{ xs: 4 }}>

                  <AutocompleteMultiple
                          options={applicationsListSelect}
                          name={applications.name}
                          label={applications.label}
                          element={applications.name}
                          multiple
                        />
              </Grid>

        </Grid>
        {/* END GRID  */}

        <Grid container spacing={2} style={{ marginTop: 15 }}>
              <Grid size={{ xs: 4 }}>
                  <CheckboxField
                    name={has_trial.name}
                    label={has_trial.label}
                  />
              </Grid>

              {values[has_trial.name] && (
                <Grid size={{ xs: 4 }}>
                  <DatePickerDefaultField 
                    label={trial_ends_at.label} 
                    name={trial_ends_at.name}
                  />
                </Grid>
              )}

              {!values[has_trial.name] && (
                <Grid size={{ xs: 4 }}>
                  <DatePickerDefaultField 
                    label={subscription_ends_at.label} 
                    name={subscription_ends_at.name}
                  />
                </Grid>
              )}
        </Grid>
        {/* END GRID  */}

    </div>
  )
}

